export default "__VITE_ASSET__VnWcHbBS__"